const MAP = {
  attivo: "emerald", completata: "emerald", pagato: "emerald", completato: "emerald", superato: "emerald", conforme: "emerald", success: "emerald",
  istituito: "sky", presentato: "sky", calcolato: "sky", in_consulenza: "sky", nuovo: "sky", info: "sky", in_corso: "sky",
  bozza: "slate", pendente: "amber", media: "slate", bassa: "slate", scaduto: "slate", annullata: "slate",
  sospeso: "amber", alta: "amber", attenzione: "amber", medium: "amber", denied: "amber",
  cessato: "red", scaduta: "red", urgente: "red", bloccato: "red", errore: "red", non_superato: "red", non_conforme: "red",
  failure: "red", blocked: "red", high: "red", critical: "red",
};
const CLS = {
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sky: "bg-sky-50 text-sky-700 border-sky-200",
  slate: "bg-slate-100 text-slate-700 border-slate-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ value, label, testId }) {
  if (!value) return <span className="text-slate-400">—</span>;
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${CLS[MAP[value] || "slate"]}`}>
      {label || String(value).replace(/_/g, " ")}
    </span>
  );
}

export function PageHeader({ title, subtitle, children, eyebrow }) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8 tm-fade">
      <div>
        {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-600 mb-2">{eyebrow}</p>}
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`bg-white border border-slate-200/80 rounded-xl shadow-[0_1px_2px_rgba(15,23,42,0.04)] ${className}`} {...rest}>{children}</div>;
}
